import {
  FETCH_AGREEMENT,
  FETCH_PAYMENT_DATA_SUCCESS,
  SUCCESS,
} from 'client/actionTypes'
import request from 'client/utils/request'

export const fetchAgreement = () => async (dispatch, getState) => {
  const {
    present: { id, isTemplate },
  } = getState().page

  if (isTemplate) {
    dispatch({
      type: FETCH_AGREEMENT + SUCCESS,
      payload: '',
    })
  } else {
    const { data } = await request.get(`/page/${id}/agreement`)

    dispatch({
      type: FETCH_AGREEMENT + SUCCESS,
      payload: data.agreement,
    })
  }
}

export const fetchPaymentDataSuccess = data => ({
  type: FETCH_PAYMENT_DATA_SUCCESS,
  payload: data,
})
